import { GraphQLUpcomingTicketsRequester } from '@cobliteam/api-lib';
import type { UpcomingTickets } from '@cobliteam/api-lib/src/__generated__/graphql';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

const QUERY_KEY = 'UPCOMING_TICKETS';

type UseUpcomingTicketsParams = {
  options?: Partial<UseQueryOptions<UpcomingTickets | null>>;
};

const requester = new GraphQLUpcomingTicketsRequester();

const useUpcomingTickets = (params?: UseUpcomingTicketsParams) => {
  return useQuery<UpcomingTickets | null>({
    ...params?.options,
    queryKey: [QUERY_KEY],
    queryFn: () => requester.getUpcomingTickets(),
  });
};

export { useUpcomingTickets, QUERY_KEY };
export default useUpcomingTickets;
